/**
 * slash-app の broadcasts API ヘルパ。レスポンス JSON はそのまま返す
 * (フィールド名は slash-app 仕様)。一斉送信メッセージ用 — 旧 slash_admin
 * Django backend の app_broadcast_messages / app_push_notifications は
 * 使用しない。
 */
import { slashAppJson } from "./slashAppClient";

export const slashAppBroadcasts = {
  /**
   * GET /api/v1/broadcasts/
   * @param {{page?:number, status?:""|"sent"|"draft"}} opts
   */
  list({ page = 1, status = "" } = {}) {
    const params = new URLSearchParams();
    params.set("page", String(page));
    if (status) params.set("status", status);
    return slashAppJson(`/api/v1/broadcasts/?${params.toString()}`);
  },

  /**
   * POST /api/v1/broadcasts/
   * @param {{
   *   target_type: "all_customers" | "studio" | "custom",
   *   target_studios?: number[],
   *   target_customers?: number[],
   *   bubbles: Array<{order:number, message_type:"text"|"image"|"video", text?:string, s3_url?:string, thumbnail_url?:string}>,
   * }} payload
   */
  create(payload) {
    return slashAppJson(`/api/v1/broadcasts/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  /** GET /api/v1/broadcasts/<id>/ */
  detail(id) {
    return slashAppJson(`/api/v1/broadcasts/${id}/`);
  },

  /** PATCH /api/v1/broadcasts/<id>/ — 下書きの内容を更新 (送信済みは 400)。 */
  update(id, payload) {
    return slashAppJson(`/api/v1/broadcasts/${id}/`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  /** POST /api/v1/broadcasts/<id>/send/ — 下書きを送信 (下書き→送信済み)。 */
  send(id) {
    return slashAppJson(`/api/v1/broadcasts/${id}/send/`, { method: "POST" });
  },

  /** DELETE /api/v1/broadcasts/<id>/ — 未送信のみ可 (送信済みは 400)。 */
  remove(id) {
    return slashAppJson(`/api/v1/broadcasts/${id}/`, { method: "DELETE" });
  },

  /** GET /api/v1/broadcasts/<id>/stats/ */
  stats(id) {
    return slashAppJson(`/api/v1/broadcasts/${id}/stats/`);
  },

  /**
   * POST /api/v1/broadcasts/upload/  (multipart/form-data)
   * bubble の画像/動画を S3 にアップロード。返り値の s3_url を bubble の
   * フィールドに渡す。
   */
  upload(file) {
    const form = new FormData();
    form.append("file", file);
    return slashAppJson("/api/v1/broadcasts/upload/", {
      method: "POST",
      body: form,
    });
  },

  /**
   * GET /api/auth/customers/?q=&limit=  (顧客検索ピッカー用)
   *
   * impersonation ピッカーと同一エンドポイント。返り値の ``results`` の
   * ``id`` は auth.User.id なので、そのまま target_customers に渡せる。
   */
  searchCustomers({ q = "", limit = 50 } = {}) {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    params.set("limit", String(limit));
    return slashAppJson(`/api/auth/customers/?${params.toString()}`);
  },
};
